module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Capture Rate"}}')
  delete Component.options._Ctor
}
